<template>
  <div>
    <!-- HEADER WITH MAINNAV: CONTACT-, WEBSITE- AND SERVICE-NAVIGATION -->

    <header>
      <div>
        <MenuMain />
      </div>
    </header>

    <!-- ASIDE LEFT - CONTENT NAV -->

    <ContainerFlex>
      <div slot="aside-left" class="hidden lg:block">
        <AsideLeft>
          <template slot="title">
            {{ submenu.title }}
          </template>
          <li
            v-for="(entry, index) in submenu.entries"
            :key="index"
            class="transition"
          >
            <a :href="entry.url">
              {{ entry.title }}
            </a>
          </li>
        </AsideLeft>
      </div>

      <!-- CENTER - BLOGPOSTS -->

      <template slot="main-content">
        <div class="mt-6 lg:mt-0 mx-4 lg:mx-0">
          <components-loader :components="components" />
        </div>
      </template>

      <!-- ASIDE RIGHT -->

      <template slot="aside-right">
        <AsideRight :coworker="consulter" />
      </template>
    </ContainerFlex>
  </div>
</template>

<script>
import MenuMain from '~/components/menu/MenuMain'

import ContainerFlex from '~/components/layoutelements/ContainerFlex'
import AsideLeft from '~/components/layoutelements/AsideLeft'
import AsideRight from '~/components/layoutelements/AsideRight'

export default {
  components: {
    MenuMain,

    ContainerFlex,
    AsideLeft,
    AsideRight,
  },
  async asyncData({ route, $axios, error }) {
    const result = await $axios.$get(route.path).catch((e) => {
      error({
        statusCode: (e.response && e.response.status) || 404,
        message: e.message,
      })
    })

    return result
  },
  data() {},
}
</script>

<style lang="scss" scoped>
// h3 {
//   @apply tracking-normal normal-case;
// }

// a {
//   @apply text-grey-darker normal-case;

//   &:hover {
//     @apply text-red;
//   }
// }
</style>
